import { createContext } from "react";

// Componente de alto orden de tipo contexto 
// Sirve para crear el contexto que nos ayuda a
// almacenar las operaciones y acciones de un usuario
// mientras este usa el sitio web

const UserContext = createContext()

export default UserContext